<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM5.80943 5.11372C5.61456 4.97872 5.34514 4.99801 5.17157 5.17157L5.11372 5.24082C4.97872 5.43569 4.99801 5.70511 5.17157 5.87868L7.29289 8L5.17157 10.1213L5.11372 10.1906C4.97872 10.3854 4.99801 10.6549 5.17157 10.8284L5.24082 10.8863C5.43569 11.0213 5.70511 11.002 5.87868 10.8284L8 8.70711L10.1213 10.8284L10.1906 10.8863C10.3854 11.0213 10.6549 11.002 10.8284 10.8284L10.8863 10.7592C11.0213 10.5643 11.002 10.2949 10.8284 10.1213L8.70711 8L10.8284 5.87868L10.8863 5.80943C11.0213 5.61456 11.002 5.34514 10.8284 5.17157L10.7592 5.11372C10.5643 4.97872 10.2949 4.99801 10.1213 5.17157L8 7.29289L5.87868 5.17157L5.80943 5.11372Z" />
  </svg>
</template>
